export const storageKey = {
  quoteTermsActiveStep: 'quoteTermsActiveStep',
  quoteTermsData: 'quoteTermsData',
  createNewOfferData: 'createNewOfferData',
};
